import { render, staticRenderFns } from "./customerStrategyGroupAction.vue?vue&type=template&id=1c2cfc2d"
import script from "./customerStrategyGroupAction.vue?vue&type=script&lang=js"
export * from "./customerStrategyGroupAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports